/** either supplements to en_UK or disagreements,
 * (note that /i‍ə/ is only diphthong that requires zero-width joiner
 * to differentiate from the case where it should be /i.ə/)
 */
export const en_UK_Overrides: Record<string, string> = {
  "&": "/ænd/",
  "a": "/ə/",
  "an": "/ɐn/",
  "and": "/ænd/",
  "at": "/æt/",
  "by": "/baɪ/",
  "can": "/kæn/",
  "for": "/fɔː/",
  "from": "/fɹɒm/",
  "has": "/hæz/",
  "her": "/hɜː/",
  "hers": "/hɜːz/",
  "him": "/hɪm/",
  "his": "/hɪz/",
  "in": "/ɪn/",
  "into": "/ɪntʊ/",
  "is": "/ɪz/",
  "it": "/ɪt/",
  "its": "/ɪts/",
  "of": "/ɒv/",
  "on": "/ɑn/",
  "or": "/ɔː/",
  "our": "/aʊə/",
  "that": "/ðæt/",
  "the": "/ðə/",
  "their": "/ðeə/",
  "this": "ðɪs",
  "to": "/tə/",
  "was": "/wɒz/",
  "we're": "/wɪə/",
  "with": "/wɪð/",

  "abrogated": "/ˈæbɹəɡˌeɪt/",
  "absent": "/æbsˈɛnt/",
  "abuse": "/ɐbjˈuːs/",
  "accent": "/ˈæksənt/",
  "acre": "/ˈeɪkɐ/",
  "advance": "/ədvˈɑːns/",
  "alas": "/ɐlˈɑːs/",
  "alexander": "/ˌɑːlikˈsɑːndɐ/",
  "agave": "/əˈɡeɪvi/",
  "ameba": "/ɐmˈiːbɐ/",
  "amuse": "/əmˈjuːz/",
  "angina": "/ænˈdʒaɪnɐ/",
  "anonymise": "/əˈnɑnəˌmaɪz/",
  "anonymised": "/əˈnɑnəˌmaɪzd/",
  "apolitical": "/ˌeɪpəlˈɪtɪkə‍l/",
  "apparel": "/əˈpæɹəl/",
  "apparent": "/ɐpˈeəɹənt/",
  "apparently": "/ɐpˈeəɹəntli/",
  "archipelago": "/ˌɑɹkəˈpɛləˌɡəʊ/",
  "archipelagos": "/ˌɑɹkəˈpɛləˌɡəʊz/",
  "australia": "/ɒˈstɹeɪljə/",
  "austen": "/ˈɒstɪn/",
  "austin": "/ˈɒstɪn/",
  "austria": "/ˈɒstɹiə/",
  "automata": "/ɔːˈtɒmətə/",
  "ayr": "/ˈeə/",
  "backyard": "/bˈækjˈɑːd/",
  "backyards": "/bˈækjˈɑːdz/",
  "barbara": "/ˈbɑbɑɹə/",
  "bebop": "/ˈbiˌbɒp/",
  "beyond": "/bɪˈɒnd/",
  "boston": "/ˈbɒstʌn/",
  "bueno": "/bwˈeɪnəʊ/",
  "buenos": "/bwˈeɪnəs/",
  "cant": "/ˈkænt/",
  "can't": "/ˈkɑːnt/",
  "candelabra": "/kˈændɪlˌɑːbɹɐ/",
  "carotene": "/kˈæɹətən/",
  "catalpa": "/kəˈtælpɐ/",
  "celebratory": "/səˌlɛbɹəˈtɔɹi/",
  "cézanne": "/sɛˈzæn/",
  "chaff": "/t‍ʃˈɑːf/",
  "chandler": "/t‍ʃˈɑːndlɐ/",
  "chili": "/t‍ʃˈɪli/",
  "cinderella": "/ˌsɪndɐˈɹɛlɐ/",
  "cleopatra": "/ˌkliəˈpɑːtɹɐ/",
  "commando": "/kəmˈɑːndəʊ/",
  "coney": "/ˈkəʊnɪ/",
  "conscripted": "/kənskɹˈɪptɪd/",
  "conscripting": "/kənskɹˈɪptɪŋ/",
  "conscription": "/kənskɹˈɪpʃən/",
  "contralto": "/kəntɹˈɑːltəʊ/",
  "corral": "/kəɹˈɑːl/",
  "covey": "/ˈkəvi/",
  "crass": "/kɹˈæs/",
  "css": "/ˈsiˈɛsˈɛs/",
  "dante": "/dˈænteɪ/",
  "deirdre": "/ˈdi‍ədɹi/",
  "dietary": "/dˈaɪətˌəɹi/",
  "disastrous": "/dˌɪsˈɑːstɹəs/",
  "distributed": "/dɪstɹˈɪbjˌuːtɪd/",
  "doctorate": "/ˈdɒktəɹɪt/",
  "does": "/dˈəz/",
  "downswing": "/dˈaʊnswˌɪŋ/",
  "dromedaries": "/ˌdɹəʊməˈdɛɹiz/",
  "dromedary": "/ˌdɹəʊməˈdɛɹi/",
  "dumbo": "/dˈʌmbəʊ/",
  "eire": "/ˈeə/",
  "elaborately": "/ɪˈlæbəɹətli/",
  "embarrass": "/ɛmbˈæɹəs/",
  "enthusiastic": "/ɛnθjˌuːzɪˈɑːstɪk/",
  "euclidean": "/juˈklɪdiən/",
  "evening": "/ˈiːvnɪŋ/",
  "eyre": "/ˈeə/",
  "failure": "/fˈeɪli‍ɐ/",
  "fiber": "/ˈfaɪbɐ/",
  "figuratively": "/ˈfɪɡʊɹətɪvli/",
  "flanders": "/ˈflɑːndɐz/",
  "florida": "/ˈflɒɹədə/",
  "fosse": "/ˈfɒs/",
  "france": "/ˈfɹɑːns/",
  "frances": "/ˈfɹɑːnsəs/",
  "francis": "/ˈfɹɑːnsəs/",
  "geisha": "/dɡˈeɪʃɐ/",
  "geishas": "/dɡˈeɪʃəz/",
  "geopolitics": "/d‍ʒˌiːəʊˈpɒlɪtɪks/",
  "gerry": "/d‍ʒˈɛɹi/",
  "glasgow": "/ˈɡlɑːsɡəʊ/",
  "gloucester": "/ˈɡlɒstɐ/",
  "gondola": "/ˈɡɒndələ/",
  "gosling": "/ˈɡɒzlɪŋ/",
  "graph": "/ɡɹˈɑːf/",
  "gustave": "/ˈɡəstɑv/",
  "he": "/hˈiː/",
  "hibachi": "/həˈbɑtʃi/",
  "hieronymus": "/haɪˈɹəʊnəməs/",
  "hoorah": "/huˈɹɐ/",
  "hooray": "/huˈɹe‍ɪ/",
  "hoorays": "/huˈɹe‍ɪz/",
  "house": "/hˈaʊs/",
  "hubris": "/hjˈuːbɹɪs/",
  "humorist": "/ˈhjuːməɹɪst/",
  "hypersensitive": "/haɪpəˈsɛnsɪtˌɪv/",
  "hypertension": "/ˌhaɪpəˈtɛnʃən/",
  "i": "/ˈaɪ/",
  "ii": "/tˈuː/",
  "iii": "/θɹˈiː/",
  "imbecile": "/ˈɪmbəsaɪl/",
  "impermeable": "/ɪmpˈɜːmiəbə‍l/",
  "inescapable": "/ˌɪnɪˈskeɪpəbəl/",
  "inescapably": "/ˌɪnɪˈskeɪpəbli/",
  "intransigent": "/ɪntɹˈɑːnsɪd‍ʒənt/",
  "iran": "/ɪˈɹɑːn/",
  "iraq": "/ɪˈɹɑːk/",
  "jagged": "/dʒˈæɡd/",
  "kerry": "/kˈɛɹi/",
  "lancashire": "/ˈlæŋkəˌʃɐ/",
  "lather": "/ˈlɑːθɐ/",
  "laurence": "/ˈlɔɹəns/",
  "lawrence": "/ˈlɔɹəns/",
  "lewis": "/lˈuɪs/",
  "liar": "/lˈaɪ‍ɐ/",
  "lieu": "/lˈjuː/",
  "lingerie": "/ˈlænʒəɹˌi/",
  "lingua": "/ˈlɪŋɡwə/",
  "loch": "/lˈɒk/",
  "mafia": "/mˈɑːfiɐ/",
  "maharajah": "/ˌmɑːhɐˈɹɑːd‍ʒɐ/",
  "mannequin": "/mˈanɪkˌɪn/",
  "masque": "/mˈɑːsk/",
  "masquerade": "/mˈɑːskwəɹˌeɪd/",
  "maugham": "/ˈmɔːm/",
  "mcclure": "/məˈklɔː/",
  "medicinal": "/mɛˈdɪsɪnəl/",
  "medievalist": "/mˌɛdˈiːvəlˌɪst/",
  "medieval": "/mˌɛdˈiːvə‍l/",
  "morale": "/məɹˈɑːl/",
  "morpheme": "/ˈmɔːfim/",
  "moth": "/ˈmɒθ/",
  "mouth": "/mˈaʊθ/",
  "moviegoer": "/mˈuːviɡˌəʊɐ/",
  "nazi": "/ˈnɑtsi/",
  "neuroses": "/njʊˈɹeʊsiz/",
  "neurosis": "/njʊˈɹeʊsəs/",
  "no": "/nˈəʊ/",
  "nonce": "/nˈɒns/",
  "none": "/nˈən/",
  "norwich": "/ˈnɒɹɪtʃ/",
  "nuclei": "/njˈuːkliaɪ/",
  "online": "/ˈɒnˈlaɪn/",
  "optometrist": "/ɒpˈtɒmɪtɹɪst/",
  "oregon": "/ˈɒɹəˌɡən/",
  "panorama": "/pˌænəɹˈɑːmɐ/",
  "panoramas": "/pˌænəɹˈɑːməz/",
  "panoramic": "/pˌænɔːɹˈɑːmɪk/",
  "pasty": "/ˈpɑːsti/",
  "patent": "/pˈeɪtənt/",
  "path": "/ˈpɑːθ/",
  "penurious": "/ˌpʌnˈjəɹiəs/",
  "perjure": "/pˈɜːd‍ʒjɐ/",
  "persimmon": "/pɜːˈsɪmən/",
  "petard": "/pɪˈtɑːd/",
  "piccolo": "/ˈpɪkəˌlə‍ʊ/",
  "piccolos": "/ˈpɪkəˌlə‍ʊz/",
  "pitiful": "/pˈɪtɪfə‍l/",
  "plaid": "/ˈplæd/",
  "plant": "/plˈɑːnt/",
  "plaque": "/plˈɑːk/",
  "plastic": "/plˈæstɪk/",
  "portrait": "/ˈpɔɹtɹɪt/",
  "portraits": "/ˈpɔɹtɹɪts/",
  "populace": "/pˈɒpjʊləs/",
  "posthumously": "/pˈəʊstjuːməsli/",
  "posthumous": "/pˈəʊstjuːməs/",
  "prayer": "/ˈpɹeə/",
  "preexisting": "/pɹiːkˈsɪstɪŋ/",
  "prescient": "/pɹˈɛsiənt/",
  "princess": "/pɹˈɪnsɛs/",
  "process": "/ˈpɹəʊsɛs/",
  "provenance": "/pɹˈɒvənəns/",
  "provolone": "/pɹˌɒvəlˈə‍ʊn/",
  "put": "/pˈʊt/",
  "pythagorean": "/ˌpaɪθəˈɡɔɹiən/",
  "rabid": "/ɹˈæbɪd/",
  "raj": "/ɹˈɑːd‍ʒ/",
  "rajah": "/ɹˈɑːd‍ʒɑː/",
  "ramen": "/ˈɹɑːmɛn/",
  "rani": "/ɹˈɑːni/",
  "read": "/ɹˈiːd/",
  "recs": "/ˈɹɛks/",
  "reggae": "/ɹˈɛɡˌeɪ/",
  "remi": "/ˈɹɛmi/",
  "ren": "/ˈɹɛn/",
  "renaissance": "/ˈɹɛnəˌsɒns/",
  "represent": "/ˌɹɛpɹɪˈzɛnt/",
  "represented": "/ˌɹɛpɹɪˈzɛntɪd/",
  "representing": "/ˌɹɛpɹɪˈzɛntɪŋ/",
  "research": "/ɹɪsˈɜːt‍ʃ/",
  "respiratory": "/ɹɪspˈɪɹətɹˌi/",
  "respite": "/ˈɹɛspɪt/",
  "resting": "/ˈɹɛstɪŋ/",
  "rex": "/ˈɹɛks/",
  "ross": "/ˈɹɒs/",
  "roulade": "/ɹuːˈlɑːd/",
  "sabbath": "/sˈæbəθ/",
  "sandra": "/ˈsɑːndɹɐ/",
  "saxophonist": "/sˈæksəfˌəʊnɪst/",
  "secret": "/sˈiːkɹət/",
  "sequester": "/sɪkwˈɛstɐ/",
  "sequestered": "/sɪkwˈɛstɐd/",
  "sequestration": "/sˌɛkwɛstɹˈeɪʃən/",
  "sequinned": "/sˈiːkwɪnd/",
  "sequin": "/sˈiːkwɪn/",
  "sequins": "/sˈiːkwɪnz/",
  "shan't": "/ˈʃɑːnt/",
  "slav": "/ˈslɑːv/",
  "southampton": "/ˌsaʊθˈæmptən/",
  "stanch": "/ˈstɑːntʃ/",
  "sterilize": "/ˈstɛɹɪˌlaɪz/",
  "stochastic": "/stəʊˈkæstɪk/",
  "subpoena": "/səˈpiːnɐ/",
  "succour": "/ˈsʌkɐ/",
  "sudan": "/suˈdɑːn/",
  "sue": "/ˈsjuː/",
  "sunshiny": "/sˈʌnʃaɪni/",
  "supplant": "/səplˈɑːnt/",
  "swansea": "/ˈswɑnsi/",
  "terracotta": "/ˌtɛɹəˈkɑtə/",
  "territories": "/tˈɛɹɪtˌəɹiz/",
  "territory": "/tˈɛɹɪtˌəɹi/",
  "tower": "/ˈtaʊɐ/",
  "trample": "/tɹˈæmpəl/",
  "transfer": "/ˈtɹænsfɐ/",
  "transform": "/ˈtɹænsfɔːm/",
  "transitory": "/tɹˈænˌsɪtəɹi/",
  "transport": "/ˈtɹænspɔːt/",
  "tudor": "/ˈtjudɐ/",
  "tuesday": "/ˈtjuːzˌdeɪ/",
  "unnavigable": "/ʌnnˈævə‍ɡəbə‍l/",
  "update": "/ʌpdˈeɪt/",
  "valuable": "/vˈæljʊbəl/",
  "venetian": "/vənˈiʃən/",
  "victual": "/ˈvɪtəl/",
  "warwick": "/ˈwɒɹɪk/",
  "weekend": "/ˈwiˌkɛnd/",
}
